<mat-sidenav-container class="container">
    <mat-sidenav
        #sidenav
        class="sidenav"
        [mode]="mobileQuery.matches ? 'over' : 'side'"
        [opened]="!mobileQuery.matches"
        [fixedInViewport]="options.value.fixed"
        [fixedTopGap]="options.value.top"
        [fixedBottomGap]="options.value.bottom"
    >
        <span class="main-info">
            @if (environment.develop) {
                <div class="corner-ribbon">Dev</div>
            }

            <div class="dashboard-logo-container">
                @if (mobileQuery.matches) {
                    <app-ui-button
                        variant="icon"
                        icon="menu"
                        (click)="toggleSidenav()"
                    ></app-ui-button>
                }

                <a class="dashboard-logo-link" routerLink="">
                    <img
                        alt="Dashboard logo"
                        src="../../../assets/images/dashboard-logo.png"
                    />
                </a>
            </div>

            <ng-template #navLink let-link>
                <a
                    class="sidenav-link"
                    routerLinkActive="active"
                    [class.sidenav-link--emphasis]="link.emphasis"
                    [class.disabled]="link.isDisabled"
                    [attr.id]="link.id || null"
                    [attr.aria-disabled]="link.isDisabled || null"
                    [routerLink]="link.isDisabled ? null : link.url"
                    [routerLinkActiveOptions]="{ exact: link.url === '/' }"
                    [matTooltip]="
                        link.tooltip || 'ERRORS.UNAUTHORIZED' | translate
                    "
                    [matTooltipPosition]="'right'"
                    [matTooltipDisabled]="!link.isDisabled"
                >
                    <mat-icon>{{ link.icon }}</mat-icon>
                    <span>{{ link.name | translate }}</span>
                </a>
            </ng-template>

            <nav id="sidebarMenu" aria-label="Main">
                <h4 class="sidenav-title">
                    {{ 'SIDENAV.STATS' | translate }}
                </h4>
                @if (isLoggedIn()) {
                    <ng-container
                        *ngTemplateOutlet="
                            navLink;
                            context: { $implicit: userStatsLink }
                        "
                    />
                }
                <ng-container
                    *ngTemplateOutlet="
                        navLink;
                        context: { $implicit: platformStatsLink }
                    "
                />

                <h4 class="sidenav-title">
                    {{ 'SIDENAV.CATALOG' | translate }}
                </h4>
                @for (link of catalogLinks; track link.url) {
                    @if (!link.isRestricted || isLoggedIn()) {
                        <ng-container
                            *ngTemplateOutlet="
                                navLink;
                                context: { $implicit: link }
                            "
                        />
                    }
                }

                @if (isLoggedIn()) {
                    <h4 class="sidenav-title">
                        {{ 'SIDENAV.TASKS' | translate }}
                    </h4>
                    @for (link of runtimeLinks; track link.url) {
                        <ng-container
                            *ngTemplateOutlet="
                                navLink;
                                context: { $implicit: link }
                            "
                        />
                    }
                }

                <div class="sidenav-divider"></div>

                <ng-container
                    *ngTemplateOutlet="
                        navLink;
                        context: { $implicit: platformServicesLink }
                    "
                />
            </nav>
        </span>

        <div class="bottom-content">
            <p class="acknowledgments">
                {{ acknowledgments }}
                <a [href]="projectUrl">{{ projectName }}</a>
            </p>

            <div class="bottom-images">
                <img
                    src="../../../assets/images/eu-flag.jpg"
                    width="50"
                    class="mr-2"
                />
                <img
                    src="../../../assets/images/dashboard-logo.png"
                    width="100"
                    class="mb-1"
                />
            </div>

            @if (voName === 'vo.imagine-ai.eu' || voName === 'vo.ai4life.eu') {
                <div class="powered-by-container">
                    <p class="acknowledgments">
                        {{ 'SIDENAV.POWERED-BY' | translate }}
                        <a href="https://ai4eosc.eu/" target="_blank">
                            {{ 'SIDENAV.AI4OS' | translate }}</a
                        >
                    </p>
                    <img
                        src="../../../assets/images/ai4-logo.png"
                        width="100"
                        class="mb-1"
                    />
                </div>
            }
        </div>
    </mat-sidenav>

    <mat-sidenav-content
        class="sidenav-content"
        [ngClass]="{
            'pl-1 pr-1': mobileQuery.matches,
            'pl-3 pr-3': !mobileQuery.matches,
        }"
        (scroll)="checkScroll($event)"
    >
        <span>
            <app-top-navbar></app-top-navbar>
            @if (isDeployedInNomad) {
                <div class="nomad-banner">
                    <mat-icon>warning</mat-icon>
                    <div
                        [innerHTML]="
                            'ERRORS.DEPLOYED-IN-NOMAD'
                                | translate
                                    : {
                                          voName: voName,
                                          statusURL:
                                              'https://status.ai4eosc.eu/',
                                      }
                        "
                    ></div>
                    <mat-icon>warning</mat-icon>
                </div>
            }
            <div class="page-content">
                <router-outlet></router-outlet>
            </div>
        </span>
        <app-footer></app-footer>
    </mat-sidenav-content>
</mat-sidenav-container>
